import {CySelector} from "../../../../common/cy-classes";
import {remToPx} from "../../../../utils/rem-to-px";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GeometryHelper} from "../geometry.helper";
import {IOnboardingStep} from "../onboarding-tour.service.interface";

export class OnboardingUserMenuStep implements IOnboardingStep {
    constructor(private _services: IServiceFactoryExtended) {}
    mainText = "ONBOARDING_USER_AREA_MAIN_TEXT";
    secondaryText = "ONBOARDING_USER_AREA_SECONDARY_TEXT";
    get targets() {
        if (!this._services.user.isAuthorized) {
            return [];
        }
        let targetSelector = this._services.mediaQuery.lAndBelow ? CySelector("cy-welcome-component") : CySelector("cy-profile-picture");
        let targetElement = document.querySelector(targetSelector);
        if (!targetElement) {
            return [];
        }
        let rectangle = targetElement.getBoundingClientRect();
        let _target =  GeometryHelper.getCircleCircumscribedToTheRectangle(rectangle);
        if (this._services.mediaQuery.xlAndAbove && this._services.user.isAuthorized) {
            let translateYAmount = remToPx(6); // translate 6rem, but I need the value in px
            _target = _target.scale(1.5).translate(0, translateYAmount);
        }
        return [_target];
    }
}
